import { ForwardedRef, MutableRefObject } from "react";
import * as _ from "lodash";

export const isMutableRef = <T = unknown>(ref: ForwardedRef<T>): ref is MutableRefObject<T> =>
  _.has(ref, "current") && !_.isNil(_.get(ref, ["current"]));
